function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveOption({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16960_118479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99962 8.82166L14.1246 4.69666L15.303 5.87499L11.178 9.99999L15.303 14.125L14.1246 15.3033L9.99962 11.1783L5.87462 15.3033L4.69629 14.125L8.82129 9.99999L4.69629 5.87499L5.87462 4.69666L9.99962 8.82166Z",
    fill: "#4A4A68",
    style: {
      fill: "#4A4A68",
      fill: "color(display-p3 0.2902 0.2902 0.4078)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16960_118479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveOption);
export default __webpack_public_path__ + "static/media/remove-option.d27953d466b8a946ffe6e41bd1708aa2.svg";
export { ForwardRef as ReactComponent };